import React, { useCallback } from 'react';
import { debounce } from '@material-ui/core';
import api from 'api/api';
import { IApiResponse } from 'utils/models';
import Input, { AccountInput } from 'ui/Input';
import InputHint from '../InputHint/InputHint';

interface IAddBeneficiaryLocal {
  submitting: boolean;
  setValidatedAccountNo: (boolean) => void;
  nameHint: string;
  currency: string;
  setNameHint: (value: string) => void;
  setCurrency: (value: string) => void;
  isLookingUp: boolean;
  setLookingUp: (value: boolean) => void;
}

interface ILocalLookupRes extends IApiResponse {
  accountName: string;
  accountCurrency: string;
}

const AddBeneficiaryLocal = ({
  submitting,
  setValidatedAccountNo,
  nameHint,
  currency,
  setNameHint,
  setCurrency,
  isLookingUp,
  setLookingUp,
}: IAddBeneficiaryLocal) => {
  const lookupAccount = (accountNumber: string) => {
    api
      .get(`transfer/lookupaccount?accountNumber=${accountNumber}`)
      .then((response: ILocalLookupRes) => {
        // console.log('respo', response);
        setNameHint(response.accountName);
        setCurrency(response.accountCurrency);
        setValidatedAccountNo(true);
      })
      .catch((error: IApiResponse) => {
        console.error(error);
        setNameHint(error.description);
        setValidatedAccountNo(false);
      })
      .finally(() => setLookingUp(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounced = useCallback(debounce(lookupAccount, 300), []);

  const handleChangeAccountNumber = ({ target }) => {
    setLookingUp(true);
    debounced(target.value as string);
  };

  return (
    <>
      <Input name="fullName" label="Full Name" disabled={submitting} />
      <AccountInput
        name="accountNumber"
        label="Account Number"
        disabled={submitting}
        onInput={handleChangeAccountNumber}
      />
      {(nameHint || isLookingUp || currency)
      && <InputHint hint={nameHint} loading={isLookingUp} onClose={() => setNameHint('')} />}
    </>
  );
};

export default AddBeneficiaryLocal;
